<template>

  <div class="patientInfo">
    <label for="">
      <span>就诊人：</span>
      <div class="fare">
        <input type="text" v-if="isInput" placeholder="选择已有就诊人" readonly @click="showPassenger" v-model="info.name">
        <input type="text" placeholder="请输入就诊人名字" v-else v-model="info.name">
        <button @click="showInput">{{isInput ? '新建' : '已有就诊人'}}</button>
        <ul class="down" v-if="isShow">
          <li v-for="(item, index) in patientList" :key="item.id" @click="passengerItem($event, item)">{{item.name}} - {{item.patientSubDtos[0] ? item.patientSubDtos[0].hospitalName : ""}}</li>
        </ul>
      </div>
    </label>
    <label for="" class="sex">
      <span>选择性别：</span>
      <p class="man"  v-if="info.sex == 1"><img src="../../assets/images/courier/xuanzhong.png" alt="" @click="handleClick(1)">男</p>
      <p class="man"  v-else><img src="../../assets/images/courier/meixuan.png" alt="" @click="handleClick(1)">男</p>
      <p class="women" v-if="info.sex == 2"><img src="../../assets/images/courier/xuanzhong.png" alt="" @click="handleClick(2)">女</p>
      <p class="women" v-else><img src="../../assets/images/courier/meixuan.png" alt="" @click="handleClick(2)">女</p>
    </label>
    <label for="">
      <span>就诊人手机号：</span>
      <input type="tel" :disabled="isForid" placeholder="请输入就诊人手机号码（必填）" v-model="info.phone">
    </label>
    <label for="" class="card">
      <span>就诊人身份证号：</span>
      <input type="tel"  :disabled="isForid"  placeholder="请输入就诊人身份证号码（必填）" v-model="info.idCard">
    </label>
      <p class="infuse">注：如您没有身份证，请填写出生年月日</p>
     <label for="" class="card">
      <span>就医账号：</span>
      <input type="tel"  :disabled="isForid"  placeholder="请输入就医账号" v-model="info.accountInfo">
    </label>

    <label for="">
      <span>门诊号,一卡通号,病案号,条形码:</span>
      <input type="tel"  :disabled="isForid"  v-model="info.barCode" placeholder="请输入就诊医院条码，病案号，一卡通号码">
    </label>
    <label for="" class="remark">
      <span>备注信息：</span>
      <textarea type="tel" placeholder="请输入备注信息" v-model="info.description"></textarea>
    </label>
    <label for="">
      <span>设置服务有效期：</span>
      <date-time :birthDay="info.serviceDate" :type="type" @time="times" />
      <span class="hint" @click="toHint">？</span>
    </label>
    <label for="">
      <span>付款方式：</span>
      <div class="fare">
        <input type="tel" placeholder="请选择" readonly @click="showPayType" v-model="payType">
        <ul class="down" v-if="isShowWay">
          <li @click="typeItem($event, 0)">在线支付诊金和服务费</li>
          <li @click="typeItem($event, 1)">仅在线支付服务费</li>
        </ul>
      </div>
    </label>
  </div>
</template>

<script>
var _this
import {reqPatient} from '../../api'
import DateTime from '../Time'
export default {
  props: ['patientInfo'],
  data () {
    return {
      isForid:false,
      info: {
        patientid: '',
        name: '',
        sex: 0, //性别
        phone: '', // 手机号
        idCard: '', // 身份证
        description: '', // 备注
        accountInfo: '', // 账户信息
        serviceDate: '', // 服务有效期
        paytype: '', // 付款方式
        barCode: '' // 医院条码
      },

      isShow: false, // 显示就诊人
      patientList: [], // 就诊人列表
      isInput: true, // 是否选择已有就诊人
      isShowWay: false, // 显示付款方式
      payType: '', // 付款方式
      type: 'datetime' // 时间类型
    }
  },
  created() {
    _this=this
    this._reqPatient()
    if(this.patientInfo != undefined) {
      setTimeout(() => {
        this.info.name = this.patientInfo.name
        this.info.sex = this.patientInfo.sex
        this.info.phone = this.patientInfo.phone
        this.info.idCard = this.patientInfo.idCard
        this.info.barCode = this.patientInfo.barCode
        this.info.description = this.patientInfo.description
        this.info.serviceDate = this.patientInfo.serviceDate
        this.payType = this.patientInfo.paytype == 0 ? '在线支付诊金和服务费' : '仅在线支付服务费'
        if(JSON.stringify(this.patientInfo) == '{}'){
          setTimeout(() => {
            this.info.name = this.patientInfo.name
            this.info.sex = this.patientInfo.sex
            this.info.phone = this.patientInfo.phone
            this.info.idCard = this.patientInfo.idCard
            this.info.barCode = this.patientInfo.barCode
            this.info.description = this.patientInfo.description
            this.info.serviceDate = this.patientInfo.serviceDate
            this.payType = this.patientInfo.paytype == 0 ? '在线支付诊金和服务费' : '仅在线支付服务费'
          },500)
        }
      },500)
    }

  },
  updated() {
    this.$emit('info', this.info)

  },
  methods: {
    // 获取就诊人
    _reqPatient() {
      reqPatient().then(res => {
        if(res.code === 200) {
          this.patientList = res.data.bussData
        }
      })
    },
    // 去富文本提示页面
    toHint() {
      this.$router.push({name: 'RichText', query: {code: '002'}})
    },
    // 获取时间
    times (time) {
      this.info.serviceDate = time
    },
    // 选择性别
    handleClick (i) {
      if(this.isForid) return
      this.info.sex = i
    },
    // 显示就诊人
    showPassenger () {
      this.isShow = !this.isShow
    },
    // 点击新增按钮
    showInput () {
      this.isForid=false
      this.isShow = false
      this.isInput = !this.isInput
      this.info.patientid = ''
      this.info.name = ''
      this.info.idCard = ''
      this.info.phone = ''
    },
    // 点击就诊人显示在input框
    passengerItem (e, item) {

      item.patientSubDtos.forEach(res=>{
        if(res.hospitalId  == _this.$parent.hospitalInfo.id){
          _this.info.barCode=res.barcode
          _this.info.accountInfo =item.jiuyiNo
        }else {
          _this.info.barCode=""
          _this.info.accountInfo =""
        }
      })
      // 2020/9/16日 选择完信息之后不允许改动 只能新建
      this.isForid=false

      this.info.sex = item.sex === '男' ? 0 : 1
      this.info.patientid = item.id
      this.info.name = e.target.innerText
      this.info.idCard = item.idCard
      this.info.phone = item.mobile
      this.info.travelNo = item.travelNo
      this.isShow = !this.isShow
    },
    // 点击付款方式显示在input框
    typeItem (e, i) {
      this.info.paytype = i
      this.payType = e.target.innerText
      this.isShowWay = !this.isShowWay
      this.$store.dispatch('getPayType', i)
    },
    // 显示付款方式
    showPayType () {
      this.isShowWay = !this.isShowWay
    },
  },
  components: {
    DateTime
  }
}
</script>

<style scoped lang="less" type="text/less">
.patientInfo{
  label{
    display: flex;
    margin-bottom: 20px;
    line-height: 40px;
    span{
      width: 112px;
      margin-right: 5px;
      text-align: right;
    }
    input{
      width: 340px;
      height: 40px;
      border:1px solid #e1e1e1;
      box-sizing: border-box;
      border-radius: 4px;
      text-indent: 10px;
      &::-webkit-input-placeholder{
        color:#c0c4cc;
      }
    }
    &.sex{
      align-items: center;
      p{
        margin-right:39px;
        img{
          width: 20px;
          height: 20px;
          margin-right: 11px;
          vertical-align: middle;
          cursor: pointer;
        }
      }

    }
    &.card{
      margin-bottom: 10px;
    }
    &.remark{
      textarea{
        width: 340px;
        height: 100px;
        resize: none;
        border:1px solid #e1e1e1;
        text-indent: 10px;
        &::-webkit-input-placeholder{
          color:#c0c4cc;
        }
      }
    }
    button{
      width: 100px;
      height: 40px;
      background: #2FA1DE;
      color:#fff;
      border:none;
      border-radius: 4px;
    }
    .hint{
      width: 26px;
      height: 26px;
      margin:7px 10px;
      background: #61aee6;
      color: #ffffff;
      line-height: 26px;
      border-radius: 50%;
      font-weight: 700;
      font-size: 18px;
      cursor: pointer;
    }
    .fare{
      position: relative;
      input{
        cursor: pointer;
      }
      .down{
        position: absolute;
        top: 42px;
        left: 0;
        width: 100%;
        background: #fff;
        box-shadow: 0px 3px 21px 0px rgba(0, 0, 0, 0.25);
        li{
          border-bottom: 1px #e1e1e1 dashed;
          text-indent: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .infuse{
    color:#999;
    margin-left:119px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hospital/PatientInfo.vue